import script from "./MobileReportDeliveryMain.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileReportDeliveryMain.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/mobile/ticket.css?vue&type=style&index=0&id=798af0a8&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-798af0a8"]])

export default __exports__